import type { DashboardAttention } from '../types/dashboard.types';

export interface Queue {
  key: keyof DashboardAttention;
  label: string;
  to: string;
}

/** Each queue links to the screen where it is worked. */
export const QUEUES: Queue[] = [
  { key: 'openComplaints', label: 'Open complaints', to: '/complaints' },
  {
    key: 'unassignedComplaints',
    label: 'Open complaints nobody is handling',
    to: '/complaints?assigned=unassigned',
  },
  { key: 'pendingRefunds', label: 'Refunds waiting for approval', to: '/refunds' },
  {
    key: 'unpaidRefunds',
    label: 'Refunds waiting for payout',
    to: '/refunds?tab=recorded&payout=unpaid',
  },
  {
    key: 'pendingPricingApprovals',
    label: 'Pricing changes waiting for approval',
    to: '/approvals?type=PricingParameterSet',
  },
  {
    key: 'lowBalanceProviders',
    label: 'Providers with a low balance',
    to: '/providers?balance=low',
  },
  {
    key: 'stuckOrders',
    label: 'Orders stuck processing',
    to: '/reconciliation?check=stuck_processing',
  },
];
